'use strict'

module.exports = parse

var fromMarkdown = require('mdast-util-from-markdown')

function parse(options) {
  var self = this

  this.Parser = parse

  function parse(doc) {
    return fromMarkdown(
      doc,
      Object.assign({}, self.data('settings'), options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: self.data('micromarkExtensions') || [],
        mdastExtensions: self.data('fromMarkdownExtensions') || []
      })
    )
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/index.js
// module id = 1473
// module chunks = 0